<template>
    <div v-if="disabled" class="cp input text" :class="[errorStatus? 'is-error': '']" :data-error="errorMsg" disabled>
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <input type="text" :value="' '+ showDate" disabled>
    </div>
    <div v-else-if="mobileMode" class="cp input" :class="[errorStatus? 'is-error': '', type]" :data-error="errorMsg">
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <input :type="type" :value="value" @change="changeValue">
    </div>
    <div v-else ref="picker" class="cp input datepicker" :class="[errorStatus? 'is-error': '']" :data-error="errorMsg">
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <a @click.prevent.stop="toggle">{{ showDate }}</a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        props: {
            nullString: {
                type: String,
                require: false,
                default: '----/--/--'
            },
            value: {
                type: String,
                require: false,
                default: ''
            },
            defaultValue: { //Panel 預設選取的值
                type: Object,
                require: false,
                default: function(){

                    return {
                        year: new Date().getFullYear(),
                        month: new Date().getMonth() + 1,
                        date: new Date().getDate(),
                        hour: 0,
                        minutes: 0
                    }
                }   
            },
            format: { //西元年 or 民國年
                type: String,
                require: false,
                default: 'AD' //ROC
            },
            type: {
                type: String,
                require: false,
                default: 'date'
            },
            label: {
                type: String,
                require: false,
                default: ''
            },
            hideLabel: {
                type: Boolean,
                require: false
            },
            errorStatus: {
                type: Boolean,
                require: false
            },
            errorMsg: {
                type: String,
                require: false
            },
            disabledMinutes: {
                type: Boolean,
                require: false
            },
            removeAble: {
                type: Boolean,
                require: false,
                default: true
            },
            disabled: {
                type: Boolean,
                require: false
            },
            dayRestriction: { //日期驗證Function(是否可選擇)
                type: Function,
                require: false,
                default: () => {
                    return true
                }
            },
        },
        data: function(){
            let _value = this.value,
                _hyphen = '-';

            if( _value ) {

                if( _value.includes('/') ) { //先看看連接號是啥
                    _hyphen = '/';
                }else if( _value.includes('-') ) {
                    _hyphen = '-';
                }else {
                    _hyphen = '';
                }
            }

            let _id = 'datePicker_'+ this.$okaTool.getUUID();

            return {
                id: _id,
                select: {},  //選擇的日期
                hyphen: _hyphen, // / - 日期連接
            }
        },
        computed: {
            ...mapState([
                'datePicker',
            ]),
            showDate: function(){
                let _type = this.type,
                    _value = this.value;

                let _result = '';

                if( _value === undefined || _value === null ) {
                    _result = this.nullString;
                }else if( _value === '' ) {

                    if( _type === 'date' ) {
                        _result = '年 /月/日';
                    }else if( _type === 'month' ) {
                        _result = '----年--月';
                    }else if( _type === 'datetime-local' ) {
                        _result = '年 /月/日 -- --:--';
                    }else if( _type === 'time' ) {
                        _result = '-- --:--';
                    }
                }else if( typeof _value === 'string' ){

                    let $value = this.getObjectValue(_value);

                    if( _type !== 'time' ) {

                        if( this.format === 'ROC' ) {
                            _result = '民國 '+ $value.year +'年'+ $value.month +'月';

                            if( $value.date ) {
                                _result = _result + $value.date +'日';
                            }
                        }else {

                            _result = $value.year +'/'+ $value.month;

                            if( $value.date ) {
                                _result = _result +'/'+ $value.date;
                            }
                        }
                    }
                    
                    if( _type === 'datetime-local' || _type === 'time' ) {
                        let _hour = parseInt($value.hour),
                            _noon = '';

                        if( _hour <= 11 ) {
                            _noon = ' 上午 ';
                        }else {
                            _noon = ' 下午 ';
                        }

                        if( _hour > 12 ) {
                            _hour = _hour - 12;
                        }

                        _result = _result + _noon + this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount($value.minutes);
                    }
                }

                return _result;
            },
            showLabel: function() {

                if( this.label ) {
                    return this.label;
                }else {
                    let _type = this.type,
                        _label = '';

                    if( _type === 'date' ) {
                        _label = '日期';
                    }else if( _type === 'month' ) {
                        _label = '月份';
                    }else if( _type === 'datetime-local' ) {
                        _label = '時間';
                    }else if( _type === 'time' ) {
                        _label = '時間';
                    }

                    return _label;
                }
            },
            mobileMode: function(){ //如果是手機就不變化
                return this.$okaTool.checkMobile();
            },
        },
        watch: {
            select: {
                handler: function(){
                    this.$emit('change');
                },
            },
            value: {
                handler: function(){
                    this.initValue();
                },
            }
        },
        methods: {
            ...mapMutations([
                'initDatePicker',
                'setDatePicker',
            ]),
            initValue: function(){ // 考慮有無 / - 並轉換西元 & 民國年
                let _value = this.value,
                    $time = this.computedValue(_value);

                this.$set(this, 'select', $time);
            },
            computedValue: function(str){
                let $result = this.$okaTool.copy(this.defaultValue)
                    // $today = new Date(),
                    // $result = {
                    //     year: $today.getFullYear(),
                    //     month: $today.getMonth() + 1,
                    //     date: $today.getDate(),
                    //     hour: 0,
                    //     minutes: 0
                    // }

                if( typeof str === 'string' ) {
                    let $ref = this.getObjectValue(str);

                    if( this.format === 'ROC' && $ref.year ) { //AD, ROC
                        $ref.year = $ref.year + 1911;
                    }

                    for( let _key in $ref ) {
                        $result[_key] = $ref[_key]
                    }
                }

                return $result;
            },
            getObjectValue: function(str){ //把傳進來的字串轉為object
                let _type = this.type, //month, date, datetime-local, time
                    $result = {}

                let _time = '', //時間
                    _ymd = ''; //日期或月份

                if( _type === 'time' ) { //13:00
                    _time = str;
                }else if( _type === 'datetime-local' ){
                    let $str = str.split('T'); //[0] => 日期/月份　[1] => 時間

                    _ymd = $str[0];
                    _time = $str[1];
                }else {
                    _ymd = str;
                }

                if( _time ) {
                    let $time = _time.split(':');

                    $result.hour = $time[0];
                    $result.minutes = $time[1];
                }

                if( _ymd ) {
                    let _dateMonth = _ymd.replace(/\/|\-/g, '');

                    if( _type === 'month' ) {

                        let _month = _dateMonth.substr(-2, 2);

                        let $regExp = new RegExp(_month + '$');
                        
                        let _year = _dateMonth.replace($regExp, '');

                        $result.month = _month;
                        $result.year = _year;
                    }else {

                        let _date = _dateMonth.substr(-2, 2),
                            _month = _dateMonth.substr(-4, 2);
                        
                        let $regExp = new RegExp(_month + _date + '$');

                        let _year = _dateMonth.replace($regExp , '');

                        $result.date = _date;
                        $result.month = _month;
                        $result.year = _year;
                    }
                }

                for( let _key in $result ) {
                    $result[_key] = parseInt($result[_key], 10);
                }

                return $result;
            },
            remove: function(){
                this.returnValue('');
                this.closePanel();
            },
            toggle: function(){
                let $datePicker = this.datePicker,
                    _id = $datePicker.id,
                    _show = $datePicker.show;

                if( _id === this.id ) {

                    if( _show ) {
                        this.closePanel();
                    }else {
                        this.openPanel();
                    }
                }else {
                    this.openPanel();
                }
            },
            openPanel: function(){

                this.setDatePicker({
                    show: true,
                    id: this.id,
                    select: this.select,
                    type: this.type,
                    target: this.$refs.picker,
                    disabledMinutes: this.disabledMinutes,
                    removeAble: this.removeAble,
                    action: this.setValue,
                    dayRestriction: this.dayRestriction
                });
            },
            closePanel: function(){
                this.initDatePicker();
            },
            setValue: function(){
                let $datePicker = this.datePicker,
                    $select = $datePicker.select,
                    _year = $select.year,
                    _month = $select.month,
                    _date = $select.date,
                    _hour = $select.hour,
                    _minutes = $select.minutes;
                
                let _hyphen = this.hyphen,
                    _returnDate = '';
                    
                if( this.format === 'ROC' ) { //or AD
                    _year = _year - 1911;
                }

                if( _year == 0 && _month == 0 && _date == 0 && _hour == 0 && _minutes == 0 ) {
                    _returnDate = '';
                }else if( this.type === 'month' ) {
                    _returnDate = _year + _hyphen + this.$okaTool.doubleCount(_month);
                }else if( this.type === 'date' ){
                    _returnDate = _year + _hyphen + this.$okaTool.doubleCount(_month) + _hyphen + this.$okaTool.doubleCount(_date);
                }else if( this.type === 'datetime-local' ){
                    _returnDate = _year + _hyphen + this.$okaTool.doubleCount(_month) + _hyphen + this.$okaTool.doubleCount(_date) +'T'+ this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount(_minutes);
                }else if( this.type === 'time' ){
                    _returnDate = this.$okaTool.doubleCount(_hour) +':'+ this.$okaTool.doubleCount(_minutes);
                }

                this.closePanel();

                this.returnValue(_returnDate);
            },
            changeValue: function(evt){ //原生
                this.returnValue(evt.target.value)
            },
            returnValue: function(value){
                this.$emit('input', value);
            }
        },
        created: function(){
            this.initValue();
        }
    }
</script>

<style scoped lang="scss">

    .cp.input-group {
        display: inline-block;
    }
</style>
